export const MESSAGE_SECOND_DURATION = 2.5
export const BUBBLE_SECOND_DURATION = 2.5
export const COMPONENT_SECOND_DURATION = 0.5

export enum COOKIE_KEYS {
  LANG = 'lang',
  IS_GIFT_POPUP_TODAY_CLOSE = 'isGiftPopupTodayClose',
  BETTING_SUCCESS_POPUP_INVISIBLE_FOR_MATCHUP = 'bettingSuccessPopupInvisible',
  BETTING_SUCCESS_POPUP_INVISIBLE_FOR_COMPONENT = 'bettingSuccessPopupInvisibleForComponent',
  TUTORIAL_DISPLAYED_BY_CIVALUE = 'tutorialDisplayed'
}

export enum LOCALSTORAGE_KEYS {
  SIGN = 'sign',
  USERID = 'userId',
  USERINFO = 'userInfo',
  NAV_OPEN_KEYS = 'navOpenKeys',
  SIDE_BAR_THEME = 'sideBarTheme',
  SIDE_BAR_COLLAPSED = 'sideBarCollapsed',
  // about socket
  SOCKET_URL = 'socketUrl',
  SOCKET_TYPE = 'socketType',
  SOCKET_IO_EVENTS = 'socketIOEvents',
  DATA_FORMAT = 'dataFormat',
  NOT_SUPPORT_POLLING = 'notSupportPolling',
  LIVE_MATCH = 'liveMatch',
  AUTH_KEY = 'auth_key',
  NOTICE_HIDE = 'noticeHide',
  TIMELINE_MATCH_ID_LIST = 'registeredMatchTimelineList',
  DELETED_TIMELINE_MATCH_ID_LIST = 'deletedMatchTimelineList',
  DIA_ADVERTISE_IMAGE_LAST_SHOWED_AT_BY_BETSLIP_BOTTOM = 'diaAdvertiseImageLastShowedAtByBetSlipBottom',
  DIA_ADVERTISE_IMAGE_LAST_SHOWED_AT_BY_GIFT_BOX = 'diaAdvertiseImageLastShowedAtByGiftBox',
  CASINO_ADVERTISEMENT_LAST_SHOWED_AT = 'casinoAdvertisementLastShowedAt',
  GIFT_BOX_NOTICE_TEXT_IMAGE_HIDE_ON_MOBILE_MENU = 'giftBoxNoticeTextImageHideOnMobileMenu',
  BETTING_SLIP_KEEP_CART_EXPLAIN_IMAGE_DISPLAYED_USER_PROMISE_IDS = 'bettingSlipKeepCartExplainImageDisplayedUserPromiseIds',
  FORE_FRONT_POPUP_SHOW_LIST = 'foreFrontPopupShowList',
  PICK_PROMOTION_BUTTON_HIDE = 'pickPromotionButtonHide',
  PICK_PROMOTION_BUTTON_LAST_SHOWED_AT = 'pickPromotionButtonLastShowedAt',
  LAST_VISIBLE_COMPANY_PICK_NOTICE_ID = 'lastVisibleCompanyPickNoticeId',
  LAST_VISIBLE_COMPANY_PICK_NOTICE_COMPANY_PICK_IDS = 'lastVisibleCompanyPickNoticeCompanyPickIds',
  GOD_BLESS_ITEM_AUTO_SELECTION_GUIDE_POPUP_SHOWED_AT = 'godBlessItemAutoSelectionGuidePopupShowedAt',
  GOD_BLESS_ITEM_AUTO_SELECTION_FREE_CLUB_ENABLED = 'godBlessItemAutoSelectionFreeClubEnabled',
  GOD_BLESS_ITEM_AUTO_SELECTION_MEMBERSHIP_CLUB_ENABLED = 'godBlessItemAutoSelectionMembershipClubEnabled',
  LAST_SELECTED_GOD_BLESS_ITEM_PROPERTY_ID = 'lastSelectedGodBlessItemPropertyId',
  USER_PICK_PROMOTION_BANNER_HIDE_TIME = 'userPickPromotionBannerLastHideTime',
  USER_PICK_PROMOTION_BANNER_HIDE = 'userPickPromotionBannerHide',
  LAST_CLUB_ID = 'adv_v2_club_id',
  ADV_SHOW_USER_PICK_FIRST_INFO = 'adv_show_user_pick_first_info',
  SCREEN_HEIGHT = 'adv_v2_screen_height',
  KEYBOARD_HEIGHT = 'adv_v2_keyboard_height',
  MATCH_ETC_FILTER_ALERT_UPDATED_AT = 'matchEtcFilterUpdatedAt',
  USER_PICK_BEST_PICK_BANNER_HIDE_7DAYS = 'userPickBestPickBannerHide7Days',
  USER_PICK_BEST_PICK_BANNER_HIDE_TIME = 'userPickBestPickBannerHideTime',
  USER_PICK_BEST_PICK_BANNER_HIDE = 'userPickBestPickBannerHide',
  LAST_USER_PICK_BEST_PICK_ID = 'last_user_pick_best_pick_id',
  ACCOUNT_TRANSFER_INFO_HIDE_TIME = 'accountTransferInfoHideTime',
  CHAT_EMOTICON_LIST = 'chatEmoticonList',
  MATCHUP_BOTTOM_BANNER_HIDE = 'matchupBottomBannerHide',
  MATCHUP_BOTTOM_BANNER_SHOW_NEXT_TIME = 'matchupBottomBannerShowNextTime',
  MATCHUP_BOTTOM_BANNER_SHOW_NEXT_7DAYS = 'matchupBottomBannerShowNext7Days',
  CHEER_FOR_TEAM_EFFECT_ENABLED = ' cheerForTeamEffectEnabled',
  POPULAR_SEARCH_TERM_NEWS_READ_URL_MAP ='popularSearchTermNewsClickedLinks',
  ADV_SHOW_TUTORIAL_VIDEO = 'adv_show_tutorial_video',
  SPORT_TALK_BUBBLE_MESSAGE_SHOW_TIME = 'sportTalkBubbleMessageShowTime',
  BET_SLIP_GUIDE_SEEN = 'betSlipGuideSeen',
  USAGE_GUIDE_VIDEO_WATCHED = 'usageGuideVideoWatched',
}


export const LOGIN_CATEGORY = ['user', 'admin']

export const GITHUB_LINK = 'https://github.com/YDJ-FE'

export const ITEM_IMG_EXT = '.png'

export enum PRICE_TYPE {
  HEART = 5,
  S_CASH = 1,
  MILEAGE = 2,
  POINT = 3,
  NONE = 0,
}

export enum CASH_TAB {
  S_CASH,
  HEART,
  ALL,
  MILEAGE,
  POINT,
  INAPP,
}

export const PRICE_TYPE_CODE_TO_STR = {
  '1': 'cash',
  '2': 'mileage',
  '3': 'point',
  '5': 'heart',
}

export const HOME_OR_AWAY_SCORE = {
  HOME: 'homeScore', AWAY: 'awayScore',
}

export const BET_TICKET_CODE = {
  ONE_MAN: '72', FIVE_MAN: '73', TEN_MAN: '74',
}

export enum MAJOR_UNIQUE_ID_TYPE {
  ALL = 0, MAJOR = -1, MINOR = -2,
}

export enum EMPTY_ICON {
  BETTOR,
  BET_HISTORY,
  MATCH,
  MATCH_DETAIL,
  MATCH_DETAIL_PC,
  MATCH_RESULT,
  MESSAGE_SENT,
  MESSAGE_RECV,
  CLUB_MESSAGE_SENT,
  CLUB_MESSAGE_RECV,
  LIVE,
  LIVE_PLAN,
  LIVE_DETAIL,
  LIVE_DETAIL_PC,
  PICK,
  PICK_SALE,
  PICK_PURCHASE,
  VISUALIZATION,
  MATCH_FILTER,
  MONEY_HISTORY,
  ITEM_HISTORY,
  MATCH_RESULT_PC,
  ONE_FOLD_CLUB,
  BET_KEEP,
  CHANGE_MATCH,
  CHANGE_MATCH_LIVE,
  FAVORITE_MATCH,
  LIVE_DISABLED,
  BET_SHARED,
  CHAT_PICK,
  DIVIDEND_CARD,
  USER_PICK_LIST,
  USER_PICK_LIST_ITEM,
  USER_PICK_PROFILE,
  USER_PICK_ACTIVITY,
  USER_PICK_COMMENT_ACTIVITY,
  COMPANY_PICK_COMMENT_ACTIVITY,
  USER_PICK_LIKE_ACTIVITY,
  USER_PICK_INDIVIDUAL_MATCH,
  TODAY_USER_PICK_LIST,
  USER_HIT_PICK_LIST,
  MATCH_RESULT_MYBET,
  LIVE_MYBET,
  PICK_COMMENT_LIST,
  ACTIVITY_HISTORY_LIST,
  BETTOR_FIND_NEW_MEMBER,
  BETTOR_FIND_FIRST_BET,
  BETTOR_FIND_HIT_SUCCESS,
  BETTOR_FIND_TODAY_BETTOR,
  USER_BLOCK_LIST,
  CHEER_FOR_TEAM_MATCH_LIST,
  SHARE_BETTING_HISTORY_LIST,
  SPORT_TALK_LIST,
  MATCHUP_DETAIL_PICK_LIST,
  MATCHUP_DETAIL_INDIVIDUAL_MATCH,
  MATCHUP_DETAIL_MATCH,
  POPULAR_SEARCH_LIST,
  TIMELINE_LIST,
  FAVORITE_USERS_LIST,
  REWARD_LIST
}


// NOTE: menus의 namespace
// 설정 후 admin에 들어가서 게임 - 글로벌 관리 - v2_menu_available_list에 추가하기
export enum SIDE_MENU {
  CLUB = 'club',
  ITEM_SHOP = 'itemshop',
  MATCHUP_RESULT = 'matchupResult',
  BETTING_HISTORY = 'betting-history',
  MESSAGE = 'message',
  BETTING_RULES = 'betting-rules',
  GIFTBOX = 'giftbox',
  MY_BANK = 'my-bank',
  PICK = 'pick',
  SAVED_BET = 'saved-bet',
  BETTOR_FIND = 'bettor-find',
  MISSION = 'mission',
  GUIDE = 'guide',
  NAVER_CAFE = 'naver-cafe',
  COUPON = 'coupon',
  INQUIRY = 'inquiry',
  ATTENDANCE = 'attendance',
  NOTICE = 'notice',
  FRIENDS_INVITATION = 'friends-invitation',
  MY_INFO = 'my-info',
}

export enum SERVER_STATE {
  OFF = 'off', ON = 'on'
}

export enum CLUB_JOIN_STATE {
  APPROVAL, AUTO, DENY,
}

export enum VIEW_TYPE {
  SKIN_SELECTOR = 'skinSelector',
  GIF_SELECTOR = 'giftSelector'
}

export enum HISTORY_TYPE {
  MONEY, ITEM
}

// NOTE: 베팅권 1만 10만 50만
export enum BET_TICKET_TYPE {
  BET_TICKET1 = 100000,
}

export enum PUBLISH_PICK_TYPE {
  HEART,
  TICKET,
}

export enum COUPON_RESULT_CODE {
  UNKNOWN = -1,
  OK = 0,
  COUPON_DEF_NOT_FOUND = 1,
  COUPON_NOT_FOUND = 2,
  COUPON_ALREADY_USED_OTHER = 3,
  COUPON_ALREADY_USED_SELF = 4,
  COUPON_EXPIRED = 5,
  COUPON_LIMITED = 6, // 사용이 제한된 쿠폰(일반)
  COUPON_LIMITED_TYPE_ONCE = 7, // 해당 타입의 쿠폰에서는 1회만 사용가능함
  COUPON_LIMITED_BUNDLE = 8, // 묶음으로 되어있는 쿠폰으로 본인에게 사용이 허락되지 않음
  COUPON_INACTIVATED = 9, // 쿠폰 사용이 불가능함
  INVALID_ACCOUNT = 10, // account 정보가 유효하기 않을때
  NOT_CERTIFICATED = 11, // 인증된 사용자가 아닐때
}

// 10만 베팅권을 1만 베팅권으로 표현하기 위한 단위
export const RATIO_TICKET = 10

export enum CLUB_NOTICE_TYPE {
  NOTICE = 0,
  EVENT = 1,
}

export enum GIFT_BTN_TYPE {
  HEART,
  TICKET
}

export enum BETTING_HISTORY_TAB_KEY {
  ONGOING = 'ongoing',
  CLOSED = 'closed',
  SHARED = 'shared',
  SAVED = 'saved',
  SPECIAL = 'special',
}

export enum MATCHUP_DETAIL_STATIC_FILTER_INDEX {
  TOTAL,
  SPECIAL,
}

export const HASH_PARAMETER = {
  RECOMMEND_ID: { KEY: 'recommendId', ATTACHABLE: true },
  MARKETING_FIRST_STATISTICS: { KEY: 'm-firstStatistic', ATTACHABLE: false },
  MARKETING_ID: { KEY: 'm-id', ATTACHABLE: true },
  ACCOUNT_TYPE: { KEY: 'accountType', ATTACHABLE: false },
  APPLE_AUTH: { KEY: 'appleAuth', ATTACHABLE: false },
  USER_NAME: { KEY: 'userName', ATTACHABLE: false },
  EMAIL: { KEY: 'email', ATTACHABLE: false },
  GAME_KIND: { KEY: 'gameKind', ATTACHABLE: false },
  FRIEND_NICK_NAME: { KEY: 'friendNickname', ATTACHABLE: true },
  ALTERNATIVE_LOGIN_TYPE: { KEY: 'alternativeLoginType', ATTACHABLE: false }
}

export const DUPLICATE_REQUEST_CHECK_TIME_LIMIT = 1000  // ms

export const API_URL = {
  GAME_TOURNAMENT_TRACKS: 'game/tournamentTracks',
  GAME_MATCHUP_DETAIL_MARKETS: 'game/matchupDetailMarkets',
  USER_GET_NOTIFICATION_DATA: 'user/getNotificationData',
  MESSAGE_GET_ONE_UNE_READ_CLUB_MESSAGE_BY_CLUB_ID: 'message/getOneUnReadClubMessageByClubId',
  JOIN_JOIN_USER: 'join/joinUser',
  USER_INFO: 'user/info',
  USER_MISSION_LIST: 'user/missionList',
  COMPONENT_IS_POSSIBLE_TO_INVITOR: 'component/isPossibleToInvitor',
  GAME_GET_GLOBAL_SETTINGS: 'game/getGlobalSettings',
  GAME_MARKET_PROVIDER: 'game/marketProvider',
  COMPONENT_MAINTENANCE_BANNER: 'component/maintenanceBanner',
  RANKING_EVENT_BUTTON_FLAGS: 'rankingEvent/buttonFlags',
}

export const DUPLICATE_REQUEST_CHECK_URL = [
  API_URL.GAME_TOURNAMENT_TRACKS,
  API_URL.GAME_MATCHUP_DETAIL_MARKETS,
  API_URL.USER_GET_NOTIFICATION_DATA,
  API_URL.USER_MISSION_LIST,
  API_URL.MESSAGE_GET_ONE_UNE_READ_CLUB_MESSAGE_BY_CLUB_ID,
  API_URL.JOIN_JOIN_USER,
  API_URL.USER_INFO,
  API_URL.COMPONENT_IS_POSSIBLE_TO_INVITOR,
  API_URL.RANKING_EVENT_BUTTON_FLAGS,
]

export const DUPLICATE_REQUEST_EXCEPTION = 'Duplicate Request Exception.'

export enum CHAT_TAB_INDEX {
  ALL, RECEIVED_MESSAGE, SHARED_BET_HISTORY,
}

export enum CHAT_TAB_INDEX_KEY {
  ALL = 'all', RECEIVED_MESSAGE = 'received-message', SHARED_BET_HISTORY = 'shared-bet-history',
}

export const LocalStorageKey = {
  SCREEN_HEIGHT: 'adv_v2_screen_height',
  KEYBOARD_HEIGHT: 'adv_v2_keyboard_height',
}

export enum GENERAL_POPUP_ID {
  PICK = 'pick',
}

export enum JOIN_URL {
  AGREE = 'agree',
  IDENTITY_VERIFICATION = 'identityVerification',
  PREVIOUS_USER_INFO = 'previousUserinfo',
  USER_INFO = 'userinfo',
  QUIZ = 'quiz',
  END = 'end',
}

export const BET_HISTORY_CLUB_ALL = 'all'

export enum BET_SLIP_BTN_TYPE {
  TEN_THOUSAND = '10000',
  FIFTY_THOUSAND = '50000',
  ONE_HUNDRED_THOUSAND = '100000',
  FIVE_HUNDRED_THOUSAND = '500000',
  ONE_MILLION = '1000000',
  FIVE_MILLION = '5000000',
  ONE = '1',
  FIVE = '5',
  TEN = '10',
  FIFTY = '50',
  RESET = '초기화',
  MAX = 'MAX'
}

export enum BET_SLIP_TAB_INDEX_KEY {
  MONEY = 'money',
  DIA = 'dia',
  BET_TICKET = 'bet_ticket',
}

export const SUCCESS_PRE_BET_TEXT = '진행중 베팅에서 베팅내역을 확인'
export const SUCCESS_PRE_BET_TEXT2 = '(취소)'
export const SUCCESS_PRE_BET_TEXT3 = '할 수 있습니다.'
export const SUCCESS_LIVE_BET_TEXT = '진행중 베팅에서 베팅내역을 확인할 수 있습니다.'
// export const MAX_BET_ALERT_TEXT1 = '1회 최대 500,000G까지 베팅할 수 있습니다.'
// desc = util.format('\'%s\' 님에게 선물', user.nick)
export const MAX_BET_ALERT_TEXT1 = '1회 최대 500,000G까지 베팅할 수 있습니다.'
export const MAX_BET_ALERT_TEXT2 = ''
export const MESSAGE_ALERT_TEXT1 = '메시지는 여기서'
export const MESSAGE_ALERT_TEXT2 = '확인할 수 있습니다.'

export enum AndroidBackAction {
  Handled = 'HANDLED',
  GoBack = 'GO_BACK',
  Exit = 'EXIT',
}

export const MOBILE_APP_RECORD_EVENT = {
  FIRST_JOIN_BY_CIVALUE: `[${process.env.APP_VERSION_PREFIX}]_first_join_by_civalue`,
  FIRST_BET_BY_CIVALUE: `[${process.env.APP_VERSION_PREFIX}]_first_bet_by_civalue`,
  JOIN_USER_NICK: `[${process.env.APP_VERSION_PREFIX}]_join_user`
}

export enum MESSAGE_TYPE_TAB_INDEX_KEY {
  MESSAGE = 'user_message',
  CLUB_MESSAGE = 'club_message',
}

export enum MESSAGE_SEND_RECEIVE_TAB_INDEX_KEY {
  SENT = 'send',
  RECEIVE = 'receive',
}

export const CLOUD_FRONT_BASE_URL = 'https://d1i7hydgfclv7m.cloudfront.net/data_center'
export const MESSAGE_IMAGE_BASE_URL = `${CLOUD_FRONT_BASE_URL}/message/images/`

export enum HOMEPAGE_SERVER_TYPE {
  PROD = 'live',
  QA = 'qa',
  TEST = 'test',
}

export enum DIA_ADVERTISEMENT_IMAGE_DISPLAYABLE_VIEW_TYPE {
  GIFT_POPUP = 'gift_popup',
  BET_SLIP_BOTTOM = 'bet_slip_bottom'
}

export const WORLD_WIDE_WEB_PREFIX = 'www.'
export const HYPER_TEXT_TRANSFER_PROTOCOL_PREFIX = 'http://'
export const HYPER_TEXT_TRANSFER_PROTOCOL_SECURE_PREFIX = 'https://'

export const URL_PREFIXES = [
  HYPER_TEXT_TRANSFER_PROTOCOL_PREFIX,
  HYPER_TEXT_TRANSFER_PROTOCOL_SECURE_PREFIX,
  WORLD_WIDE_WEB_PREFIX,
]

export const SPACE_SEPARATOR = ' '
export const NEW_LINE_SEPARATOR = '\n'
export const URL_SEPARATORS = [SPACE_SEPARATOR, NEW_LINE_SEPARATOR]

export const BODY_SCROLL_HIDDEN = 'body-scroll-hidden'
export const BODY_X_SCROLLABLE = 'body-x-scrollable'

export const TOUCH_ACTION_DISABLED = 'touch-action-disabled'
export const TOUCH_ACTION_ENABLED = 'touch-action-enabled'

export const ALL_MEMBER_USER_PICK_KEY = 'allMemberPicks'

export const CLASSNAMES = Object.freeze({
  ADV_DISABLE_SCROLL: 'adv-disable-scroll',
})

export enum MATCHUP_DETAIL_CONTENT_TAB_KEY {
  BET,
  MATCH,
  PICK,
  SPORT_TALK,
}

export enum PREMIUM_PICKS_TAB_KEY {
  ALL = 'all',
  PROKEY = 'prokey',
  DOEL_NOM_DOEL = 'doel-nom-doel',
}
